import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const MIDDLE_NAME_SCHEMA_FIELD_NAME = "middleName";

const MAX_LENGTH = 30;

export const getMiddleNameFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .max(MAX_LENGTH)
    .alphaSpace()
    .label(i18n("MiddleNameFormField__LABEL").toLowerCase());
